import { getStreamDetail, getStreamDetailByUserId,getStreamPlannerView, doCsvUploadForStudentStream, doCsvUploadForAlumniStream,
  doCsvUploadForAdvisorStream, doCsvUploadForCourseOptions, doCsvUploadForAARRequirements,
  getAlumniStreamRecommendations, getAdvisorStreamRecommendations, streamToCsvFile, getStudentSpecialNotes,
  setLockStreamTrue, setLockStreamFalse, updateEntityVerification, putCsvUploadForInstitutionCareers } from '../api'
import { getCourseDetail } from '../../course/api'

export const loadStreamDetail = ({ state, commit }, uuid) => {
  return getStreamDetail(uuid).then(data => {
    if (data !== undefined) {
      commit('LOAD_STREAM', data)
      commit('LOAD_SHOW_ENTITY', false)
      commit('LOAD_SHOW_CATEGORY', false)
    }
    return data
  })
}

export const loadStreamDetailByUserId = ({ state, commit }, userId) => {
  return getStreamDetailByUserId(userId).then(data => {
    if (data !== undefined) {
      commit('LOAD_STREAM', data)
      commit('LOAD_SHOW_ENTITY', false)
      commit('LOAD_SHOW_CATEGORY', false)
    }
    return data
  })
}

export const loadStreamPlannerView = ({ state, commit }, uuid) => {
  return getStreamPlannerView(uuid).then(data => {
    if (data !== undefined) {
      commit('LOAD_STREAM_PLANNER', data.plannerView)
      commit('LOAD_ACADEMIC_YEARS', data.academicYears)
      commit('LOAD_TERMS', data.terms)
      commit('LOAD_BLOCKS', data.blocks)
    }
    return data
  })
}

export const loadStreamEntity = ({ state, commit }, entity) => {
  commit('LOAD_SHOW_CATEGORY', false)
  if (entity.entityType === 'deliverycontext') {
    return getCourseDetail(entity.originUuid).then((data) => {
      if (data !== undefined) {
        commit('LOAD_STREAM_ENTITY', data)
        commit('LOAD_SHOW_ENTITY', true)
      }
      return data
    })
  } else {
    commit('LOAD_STREAM_ENTITY', entity)
    commit('LOAD_SHOW_ENTITY', true)
    return entity
  }
}

export const lockStream = ({ state, commit }, uuid) => {
  return setLockStreamTrue(uuid).then(data => {
    return data
  })
}

export const unlockStream = ({ state, commit }, uuid) => {
  return setLockStreamFalse(uuid).then(data => {
    return data
  })
}

export const loadCategory = ({ state, commit }, category) => {
  commit('LOAD_CATEGORY', category)
  commit('LOAD_SHOW_ENTITY', false)
  commit('LOAD_SHOW_CATEGORY', true)
  return category
}

export const uploadStudentStreamCsvFile = ({ state, commit }, {institutionId, createdByUuid, fileData}) => {
  return doCsvUploadForStudentStream(institutionId, createdByUuid, fileData).then(res => {
    return res
  })
}

export const uploadAlumniStreamCsvFile = ({ state, commit }, {institutionId, createdByUuid, fileData}) => {
  return doCsvUploadForAlumniStream(institutionId, createdByUuid, fileData).then(res => {
    return res
  })
}

export const uploadAdvisorStreamCsvFile = ({ state, commit }, {institutionId, createdByUuid, folderId, fileData}) => {
  return doCsvUploadForAdvisorStream(institutionId, createdByUuid, folderId, fileData).then(res => {
    return res
  })
}

export const uploadCourseOptionsStreamCsvFile = ({ state, commit }, {institutionId, createdByUuid, fileData}) => {
  return doCsvUploadForCourseOptions(institutionId, createdByUuid, fileData).then(res => {
    return res
  })
}

export const uploadInstitutionCareersCsvFile = ({ state, commit }, {institutionId, createdByUuid, fileData}) => {
  return putCsvUploadForInstitutionCareers(institutionId, createdByUuid, fileData).then(res => {
    return res
  })
}

export const uploadAARRequirementsCsvFile = ({ state, commit }, {institutionId, createdByUuid, fileData}) => {
  return doCsvUploadForAARRequirements(institutionId, createdByUuid, fileData).then(res => {
    return res
  })
}

export const loadAlumniStreamRecommendations = ({ state, commit }, {recommendationData}) => {
  return getAlumniStreamRecommendations(recommendationData).then(response => {
    commit('LOAD_ALUMNI_STREAM_RECOMMENDATIONS', response)
    return response
  })
}

export const loadAdvisorStreamRecommendations = ({ state, commit }, {recommendationData}) => {
  return getAdvisorStreamRecommendations(recommendationData).then(response => {
    commit('LOAD_ADVISOR_STREAM_RECOMMENDATIONS', response)
    return response
  })
}

export const exportStreamToCsv = ({ state, commit }, {uuid}) => {
  return streamToCsvFile(uuid).then(response => {
    return response
  })
}

export const loadStudentSpecialNotes = ({ state, commit }) => {
  return getStudentSpecialNotes().then(response => {
    return response
  })
}

export const setPlanStreamSearchType = ({ state, commit }, searchType) => {
  commit('UPDATE_PLAN_STREAM_SEARCH_TYPE', searchType)
}

export const loadStreamEntityVerification = ({ state, commit }, entity) => {
  return updateEntityVerification(entity)
}



// WEBPACK FOOTER //
// ./src/app/stream/vuex/actions.js